@if (moonData && currentWeather && !isLoading) {
  <vw-extendable-card [headerTemplate]="cardHeaderTemplate"
    [bodyTemplate]="cardBodyTemplate">
  <ng-template #cardHeaderTemplate>
    <div class="flex items-center w-full h-12">
      <div [style.background-color]="'#E4E1FE'" class="h-full flex items-center px-4 w-56 gap-2">
        <div class="w-8 h-full flex items-center justify-center shrink-0">
          <vw-moon-icon class="text-[#261E77]" />
        </div>
        <p class="text-xs font-medium whitespace-normal text-[#261E77]">
          {{ 'home.weather.moon.phases.' + moonData.moonPhase | translate }}
        </p>
      </div>
      <div class="w-full h-full flex items-center mr-8">
        <p class="text-xs pl-3 text-gray-700">{{ 'home.weather.moon.advices.' +
          moonData.moonPhase | translate }}</p>
      </div>
    </div>
  </ng-template>
  <ng-template #cardBodyTemplate>
    <div class="w-full flex h-max p-4 justify-between items-end" [style.background-color]="'#E4E1FE'">
      <div class="w-2/3 h-full flex flex-col gap-2">
        <div class="flex flex-col gap-0.5">
          <h5 class="text-[16px] font-medium text-gray-800">
            {{currentDate | date: 'EEEE dd MMMM' | titlecase}}
          </h5>
          <p class="text-xs text-gray-700">{{moonData.location}}</p>
        </div>
        <h3 class="text-[32px] font-semibold  text-[#261E77]">
          {{currentWeather.currentTemperature}}°c
        </h3>
        <div class="flex items-center gap-2">
          <ul class="flex items-center gap-2">
            <li class="flex items-center gap-[2px]">
              <span>
                <vw-icon-svg iconUrl="/assets/svg/weather/weather-arrow-up.svg" additionalClasses="cursor-pointer"
                  width="16" height="16"></vw-icon-svg>
              </span>
              <span class="text-xs text-[#261E77]">
                {{currentWeather.maxTemperature}}°c</span>
            </li>
            <li class="flex items-center gap-[2px]">
              <span>
                <vw-icon-svg iconUrl="/assets/svg/weather/weather-arrow-down.svg" additionalClasses="cursor-pointer"
                  width="16" height="16"></vw-icon-svg>
              </span>
              <span class="text-xs text-[#261E77]">{{currentWeather.minTemperature}}°c</span>
            </li>
            <li class="flex items-center gap-[2px]">
              <span>
                <vw-icon-svg iconUrl="/assets/svg/weather/weather-droplet.svg" additionalClasses="cursor-pointer"
                  width="16" height="16"></vw-icon-svg>
              </span>
              <span class="text-xs text-[#261E77]">{{currentWeather.totalPrecipitation}}mm</span>
            </li>
          </ul>
        </div>
        @if (lunarDay) {
          <div class="flex items-center gap-2 mt-1 flex-wrap">
            <span class="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-[#261E77] text-white text-[10px] font-medium">
              <span>{{ moonPathIcon }}</span>
              {{ 'home.lunar.moonPath.' + lunarDay.moonPath | translate }}
            </span>
            <span class="inline-flex items-center px-2 py-0.5 rounded-full bg-[#261E77]/80 text-white text-[10px] font-medium">
              {{ 'home.lunar.influence.' + lunarDay.influence | translate }}
            </span>
            @for (event of lunarDay.events; track event) {
              <span class="inline-flex items-center px-2 py-0.5 rounded-full bg-amber-500 text-white text-[10px] font-medium">
                {{ 'home.lunar.events.' + event | translate }}
              </span>
            }
          </div>
        }
      </div>
      <div class="w-1/3 h-full flex items-end justify-end">
        <vw-icon-svg [iconUrl]="weatherImg" class="h-full" additionalClasses="cursor-pointer h-full" width="auto"
          height="100%"></vw-icon-svg>
      </div>
    </div>
  </ng-template>
  </vw-extendable-card>
}
@if (isLoading) {
  <vw-skeleton-loader [width]="'100%'" [height]="'48px'"
    [borderRadius]="'0.75rem'"></vw-skeleton-loader>
}